import * as React from "react";
import MassConfigSummary from "../../components/Forms/MassConfigPremisesComponents/Summary/Summary";

export default function MassConfigSummaryView() {
  return <MassConfigSummary />;
}
